import React, { useState, useEffect } from "react";
import { Table, Input, Select, Tag, message, Space, Dropdown, Menu, Modal, Row, Col, Typography, Button } from "antd";
import { MoreOutlined, DownloadOutlined, FileTextOutlined } from "@ant-design/icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Axios from "../../../services/AxiosInterceptor";

const STORAGE_URL = process.env.REACT_APP_API_URL || "https://yogamatic.in/api/upload";

const { Option } = Select;
const { Title, Text } = Typography;

const MemberList = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchEmail, setSearchEmail] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
const navigate=useNavigate()
  // ✅ Fetch Members from API
  useEffect(() => {
    fetchMembers();
  },[searchEmail, statusFilter]);
console.log("member",members)
  const fetchMembers = async () => {
    setLoading(true);
    try {
      // let url = "http://13.201.108.246:5000/api/get_members";
      // if (searchEmail || statusFilter) {
      //   url += `?email=${searchEmail}&status=${statusFilter}`;
      // }

      const response = await Axios.get("api/get_members");
      if (response.data.success) {
        
        setMembers(response.data.data);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching members:", error);
      message.error("Failed to fetch member data.");
    }
    setLoading(false);
  };

  // ✅ Handle View Action
  const handleView = (record) => {
    setSelectedMember(record);
    setIsModalVisible(true);
  };

  // ✅ Close Modal
  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedMember(null);
  };
  
  const handleEdit =(record)=>{
    navigate(`/EditMembers/${record._id}`)
console.log(record._id)
  }

  // ✅ Action Menu for Dropdown
  const actionMenu = (record) => (
    <Menu>
      <Menu.Item key="view" onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="edit" onClick={() => handleEdit(record)}>
        Edit
      </Menu.Item>
    </Menu>
  );

  // ✅ Table Columns with Actions
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Membership",
      dataIndex: "membership",
      key: "membership",
      render: (text) => <Tag color="blue">{text.replace("_", " ")}</Tag>,
    },
    {
      title: "Joining Date",
      dataIndex: "joiningDate",
      key: "joiningDate",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Expiry Date",
      dataIndex: "expiryDate",
      key: "expiryDate",
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Dropdown overlay={actionMenu(record)} trigger={["click"]}>
          <MoreOutlined style={{ fontSize: "20px", cursor: "pointer" }} />
        </Dropdown>
      ),
    },
  ];

  return (
    <div style={{ maxWidth: "1200px", margin: "auto", padding: "20px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>🧘 Member List</h2>

     {/* Filters */}
     <Space style={{ marginBottom: "20px", display: "flex"}}>
        <Input
          placeholder="Search by Email"
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          style={{ width: "100%" }}
        />
        <Select
          placeholder="Filter by Status"
          value={statusFilter}
          onChange={setStatusFilter}
          style={{ width: "100%" }}
        >
          <Option value="">All</Option>
          <Option value="Active">Active</Option>
          <Option value="Expired">Expired</Option>
        </Select>
        <Button onClick={()=>navigate("/Members")}>Add Member</Button>
      </Space>

      {/* Member Table */}
      <Table
        columns={columns}
        dataSource={members}
        loading={loading}
        rowKey="_id"
        bordered
        pagination={{ pageSize: 5 }}
      />

      {/* Modal for Viewing Member Details */}
      {/* <Modal
        title={<Title level={3} style={{ color: "#4CAF50", textAlign: "center" }}>Member Details</Title>}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
      >
        {selectedMember && (
          <div style={{ padding: "15px", background: "#f9f9f9", borderRadius: "8px" }}>
            <Row gutter={16}>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Name:</Text> {selectedMember.name}
              </Col>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Email:</Text> {selectedMember.email}
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: "10px" }}>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Age:</Text> {selectedMember.age}
              </Col>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Gender:</Text> {selectedMember.gender}
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: "10px" }}>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Membership:</Text> {selectedMember.membership.replace("_", " ")}
              </Col>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Status:</Text> 
                <Tag color={selectedMember.status === "Active" ? "green" : "red"}>{selectedMember.status}</Tag>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: "10px" }}>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Joining Date:</Text> {new Date(selectedMember.joiningDate).toLocaleDateString()}
              </Col>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Expiry Date:</Text> {new Date(selectedMember.expiryDate).toLocaleDateString()}
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: "10px" }}>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Address:</Text> {selectedMember.address}
              </Col>
              <Col span={12}>
                <Text strong style={{ color: "#4CAF50" }}>Yoga Type:</Text> {selectedMember.yogaType}
              </Col>
            </Row>
          </div>
        )}
      </Modal> */}
      <Modal
  title={<Title level={3} style={{ color: "#4CAF50", textAlign: "center" }}>Member Details</Title>}
  visible={isModalVisible}
  onCancel={handleCancel}
  footer={null}
  width={600}
>
  {selectedMember && (
    <div style={{ padding: "15px", background: "#f9f9f9", borderRadius: "8px" }}>
      {/* Row 1: Name, Email */}
      <Row gutter={16}>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Name:</Text> {selectedMember.name}
        </Col>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Email:</Text> {selectedMember.email}
        </Col>
      </Row>

      {/* Row 2: Age, Gender */}
      <Row gutter={16} style={{ marginTop: "10px" }}>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Age:</Text> {selectedMember.age}
        </Col>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Gender:</Text> {selectedMember.gender}
        </Col>
      </Row>

      {/* Row 3: Membership, Status */}
      <Row gutter={16} style={{ marginTop: "10px" }}>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Membership:</Text> {selectedMember.membership.replace("_", " ")}
        </Col>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Status:</Text> 
          <Tag color={selectedMember.status === "Active" ? "green" : "red"}>{selectedMember.status}</Tag>
        </Col>
      </Row>

      {/* Row 4: Joining & Expiry Dates */}
      <Row gutter={16} style={{ marginTop: "10px" }}>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Joining Date:</Text> {new Date(selectedMember.joiningDate).toLocaleDateString()}
        </Col>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Expiry Date:</Text> {new Date(selectedMember.expiryDate).toLocaleDateString()}
        </Col>
      </Row>

      {/* Row 5: Address, Yoga Type */}
      <Row gutter={16} style={{ marginTop: "10px" }}>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Address:</Text> {selectedMember.address}
        </Col>
        <Col span={12}>
          <Text strong style={{ color: "#4CAF50" }}>Yoga Type:</Text> {selectedMember.yogaType}
        </Col>
      </Row>

      {/* Medical Report - Download from S3 */}
      {selectedMember.medicalReportS3Key && (
        <Row style={{ marginTop: "15px", textAlign: "center" }}>
          <Col span={24}>
            <Text strong style={{ color: "#4CAF50" }}>Medical Report:</Text>
            <div style={{ marginTop: "10px" }}>
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={() => {
                  const downloadUrl = `${STORAGE_URL}/${selectedMember.medicalReportS3Key}`;
                  window.open(downloadUrl, '_blank');
                }}
                style={{ background: "#4CAF50", borderColor: "#4CAF50" }}
              >
                <FileTextOutlined /> Download Medical Report (PDF)
              </Button>
            </div>
          </Col>
        </Row>
      )}
      
      {!selectedMember.medicalReportS3Key && (
        <Row style={{ marginTop: "15px", textAlign: "center" }}>
          <Col span={24}>
            <Text type="secondary" italic>No medical report uploaded</Text>
          </Col>
        </Row>
      )}

    </div>
  )}
</Modal>

    </div>
  );
};

export default MemberList;
